import { useEffect, useState } from 'react';
import { BlueLocationIcon } from '../../Icons';
import styles from './styles.module.scss';
import { Edit, TooltipIcon } from 'components/Icons';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getInviteClientDrawerValues } from 'store/selectors/app';

type ClientAddressesPropsType = {
  addresses: any[];
  campaigns: any[];
  editAddressHandler: (uuid: string) => void;
  withCampaigns: boolean;
  handleContinue: () => void;
};

const ClientAddresses = (props: ClientAddressesPropsType) => {
  const { addresses, editAddressHandler, campaigns, withCampaigns, handleContinue } = props;
  const clientValues = useSelector(getInviteClientDrawerValues);
  const [targetAddresses, setTargetAddresses] = useState<any[]>([]);

  useEffect(() => {
    let filteredResults: any[] = [];

    if (withCampaigns)
      filteredResults = addresses.filter((address) => address?.campaignIds?.length);
    else filteredResults = addresses.filter((address) => !address?.campaignIds?.length);

    if (filteredResults.length) setTargetAddresses(filteredResults);
    else handleContinue();
  }, [addresses, withCampaigns]);

  const getSequenceName = (id: number) => {
    let name = '-';
    const found = campaigns.find((campaign) => campaign.Id === id);
    if (found?.Name) name = found.Name;
    return name;
  };

  return (
    <div className={styles.clientAddresses}>
      <div className={styles.heading}>Here’s what will happen next:</div>
      <div className={styles.content}>
        {!withCampaigns ? (
          <div className={styles.text}>
            The following {targetAddresses?.length > 1 ? 'addresses' : 'address'} will be added to
            your retention portfolio and {clientValues?.inviteClientValues?.firstName}’s homeowner
            dashboard:
          </div>
        ) : null}
        {targetAddresses.map((address) => (
          <div
            className={classNames(
              styles.addressContainer,
              withCampaigns ? styles.addressContainerStart : styles.addressContainerCenter,
              { [styles.disableDivider]: targetAddresses?.length < 2 },
            )}
          >
            <div className={styles.left}>
              <BlueLocationIcon />
            </div>
            {withCampaigns ? (
              <div className={styles.middle}>
                <span className={styles.bold}>{address.address.delivery_line_1}</span>
                {` will be enrolled in the following KIT sequence${
                  address.campaignIds.length === 1 ? '' : 's'
                }:`}
                {address.campaignIds.map((campaignId) => (
                  <div className={styles.bold}>{getSequenceName(campaignId)}</div>
                ))}
              </div>
            ) : (
              <div className={styles.middle}>
                <span className={styles.bold}>{address.address.delivery_line_1}</span>
              </div>
            )}
            <div className={styles.right} onClick={() => editAddressHandler(address.uuid)}>
              <Edit stroke={'#747475'} size={'24'} strokeWidth={'2'} />
            </div>
          </div>
        ))}
        <div className={styles.note}>
          <TooltipIcon className={styles.tooltipIcon} size={'17'} color={'#676767'} />
          {withCampaigns
            ? `${
                targetAddresses?.length > 1 ? 'These' : 'It'
              } will also be added to your retention portfolio and ${
                clientValues?.inviteClientValues?.firstName
              }’s homeowner dashboard.`
            : `You can enroll these addresses in KIT sequences from your Radar module.`}
        </div>
      </div>
    </div>
  );
};

export default ClientAddresses;
